import { TabOption } from "../../../utils/integrationConfigData";

interface IntegrationTabsProps {
  tabs: TabOption[];
  activeTab: string;
  onChange: (tabId: string) => void;
}

const IntegrationTabs = ({
  tabs,
  activeTab,
  onChange,
}: IntegrationTabsProps) => {
  return (
    <div className="ic-tabs" role="tablist" aria-label="Integration sections">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          className={`ic-tab ${activeTab === tab.id ? "active" : ""}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default IntegrationTabs;
